import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../store/views/entityView";
import { myCoursesFilter, studyGroupsFilter } from "../utils/entitiesFiltersUtils";

export const useNmmDomains = () => {
    const myCourses = useSelector((state) => selectEntitiesByFilters(state, myCoursesFilter));
    const studyGroups = useSelector((state) => selectEntitiesByFilters(state, studyGroupsFilter));
    const extraNmmDomainsRaw = useSelector((state) => state.uiData.general?.extraNmmDomains);
    const [allNmmDomains, setAllNmmDomains] = useState([]);

    useEffect(() => {
        const myCoursesDomains = myCourses?.filter((x) => x.domain)?.map((x) => x.domain) || [];
        const extraNmmDomains = extraNmmDomainsRaw?.filter((x) => myCoursesDomains.includes(x)) || [];
        const studyGroupsDomains = studyGroups?.filter((x) => x.domainName)?.map((x) => x.domainName) || [];
        setAllNmmDomains([...new Set([...studyGroupsDomains, ...extraNmmDomains])])
    }, [myCourses, studyGroups, extraNmmDomainsRaw]);

    return allNmmDomains;
}
